import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IEquipment, IEquipmentsListKeys } from '../model/equipmentsList ';

export const allEquipmentsListKey = (keys?: IEquipmentsListKeys): [string, string] => [
  'equipmentsAllList',
  keys?.locationId || '',
];

export const allEquipmentsListFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof allEquipmentsListKey>>) =>
  apiClient.get(`${APP_API_URL}equipments/list`, {
    params: queryKey[1] ? { location_id: queryKey[1] } : {},
  });

const allEquipmentsListSelect = ({ data }: AxiosResponse<{ list: IEquipment[] }>) => data?.list || [];

export const useAllEquipmentsListQuery = (keys: IEquipmentsListKeys) => {
  return useQuery({
    queryKey: allEquipmentsListKey(keys),
    queryFn: allEquipmentsListFn,
    select: allEquipmentsListSelect,
  });
};
